import React, { useState, useEffect } from 'react';
import '../game/Game.scss';
import './Trailer.scss'
import City from '../game/City';
import Card from '../game/Card';
import { useDispatch } from 'react-redux';
import { startTrailer } from '../../redux/trailerSlice';
import DiceRoll from '../game/DiceRoll';
import EnergyContainer from '../game/EnergyContainer';
import { clearAnimationQueue, addToAnimationQueue } from '../../redux/animationSlice';
import { setPlayer, setRollsLeft, clearDiceToRoll, setCurTurnPlayerId, updateDice, setMyPlayerId, updateBoardPlayers } from '../../redux/gameSlice';

const TEST_STOP_SWITCHING_STAGES = false;
const stageDurations = {
  1: 2300,
  2: 6500,
  3: 2800,
  4: 4900,
  5: 2800,
  6: 3800,
  7: 12500
};

function rand(min, max) {
  return Math.floor(Math.random() * (max + 1 - min) + min);
}

export default function Trailer(props) {
  const dispatch = useDispatch();
  const [stage, setStage] = useState(0);
  let content = null;

  useEffect(() => {
    if (stage === 7) {
      setTimeout(() => setStage(0), stageDurations[stage]);
      return;
    }

    if (stage < 1) {
      return;
    }

    if (stage === 1) {
      dispatch(startTrailer());
    }

    if (TEST_STOP_SWITCHING_STAGES === true) {
      return;
    }

    setTimeout(() => setStage(stage + 1), stageDurations[stage]);
  }, [dispatch, stage]);

  if (stage === 0) {
    content = <button className="button" onClick={() => setTimeout(() => setStage(1), 1000)}>WATCH TRAILER</button>;
  }

  if (stage === 1) {
    let text = 'Are you the new king of the town?';
    content = <div className="text-stage right">
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
    </div>
  }

  if (stage === 2) {
    const data = { "action": "game-info", "my_pid": 1, "started_at": 1590008123038, "cur_turn_player_id": 1, "player_city_center": 0, "player_lake": 0, "rolls_left": 3, "dice_roll": [0, 0, 0, 0, 0, 0, 0, 0], "table_cards": ["earthquake", "medical_treatment", "car_dealership"], "card_pile_count": 40, "winner": 0, "yield_status": { "is_yielding": false }, "player_health_at_roll_time": 0, "players_in_town_at_roll_time": [0, 0] };

    dispatch(clearAnimationQueue());
    dispatch(setMyPlayerId(data.my_pid));
    dispatch(setPlayer({ "id": 1, "is_owner": true, "name": "normal-player", "health": 1, "stars": 0, "energy": 5, "monster_id": 2, "cards": ["helping_cube", "helping_cube"], "is_connected": true }));
    dispatch(setPlayer({ "id": 2, "is_owner": false, "name": "player-in-lake-or-something", "health": 1, "stars": 0, "energy": 0, "monster_id": 4, "cards": [], "is_connected": true }));
    dispatch(setPlayer({ "id": 3, "is_owner": false, "name": "filler-so-we-can-use-the-lake", "health": 1, "stars": 0, "energy": 0, "monster_id": 4, "cards": [], "is_connected": true }));
    dispatch(setPlayer({ "id": 4, "is_owner": false, "name": "filler-so-we-can-use-the-lake", "health": 1, "stars": 0, "energy": 0, "monster_id": 4, "cards": [], "is_connected": true }));
    dispatch(setPlayer({ "id": 5, "is_owner": false, "name": "filler-so-we-can-use-the-lake", "health": 1, "stars": 0, "energy": 0, "monster_id": 4, "cards": [], "is_connected": true }));
    dispatch(setRollsLeft(data.rolls_left));
    dispatch(clearDiceToRoll());
    dispatch(setCurTurnPlayerId(data.cur_turn_player_id));
    dispatch(updateDice(data.dice_roll));

    const randomDiceSet = (rollSet) => {
      let newDiceRoll = [];
      for (let i = 0; i < 8; ++i) {
        if (rollSet[i] === true) {
          newDiceRoll[i] = rand(1, 6);
        } else {
          newDiceRoll[i] = 0;
        }
      }

      return newDiceRoll;
    };

    let intervalsLeft = 12;
    let interval = setInterval(() => {
      dispatch(updateDice(randomDiceSet([true, true, true, true, true, true, true, true, true])));
      intervalsLeft--;
      if (intervalsLeft === 0) {
        dispatch(updateDice([4, 4, 3, 5, 6, 5, 5, 5]));
        clearInterval(interval);
        return;
      }
    }, 400);

    setTimeout(() => {
      dispatch(addToAnimationQueue({
        type: "player-entering-town",
        duration: 2000,
        entering_city: true,
        entering_lake: true,
        onStart: updateBoardPlayers({
          lake: 1,
          center: 2,
        })
      }));
    }, 1000);

    content = <div id="game">
      <div id="red-pan"></div>
      <City />
      <div id="player-action-panel-container">
        <div className="center-structure">
          {<DiceRoll />}
          {<EnergyContainer />}
        </div>
      </div>
    </div>;
  }

  if (stage === 3) {
    let text = 'Empower your monster with cards out of this world!';
    content = <div className="text-stage top">
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
    </div>
  }

  if (stage === 4) {
    content = <div id="game">
      <City />
      <Card type="parachute_invasion" />
      <Card type="the_businessman" />
      <Card type="gust" />
    </div>
  }

  if (stage === 5) {
    let text = 'Defeat your enemies and conquer the crown!';
    content = <div className="text-stage bottom">
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
      <div>{text}</div>
    </div>
  }

  if (stage === 6) {
    content = <div id="cute-monsters">
      <div id="mustache" className="monster"></div>
      <div id="beepy" className="monster"></div>
      <div id="crab" className="monster"></div>
      <div id="root" className="monster"></div>
      <div id="hamster" className="monster"></div>
    </div>
  }

  if (stage === 7) {
    content = <div id="trailer-outro">
      <div id="octopus"></div>
      <div id="crown"></div>
      <div id="logo"></div>
      <div id="black-pan"></div>
    </div>
  }

  return <div id="trailer-wrap">
    <div id="trailer" className={`current-stage-${stage}`}>
      <div id="protection-pan"></div>
      {content}
    </div>
  </div>
}
